import { getCategoriesDatasource } from '@monoimin/datasources';

import { getInvestmentProgramNames } from '@monoimin/storyblok/getInvestmentProgramNames';

import { NONE_VALUE } from '../constants';

import { createPageDate } from './createPageDate';
import { createPageCountry } from './createPageCountry';

import type { PassportPageStoryblok } from '@monoimin/sb-types';

import type { AnalyticsDataCollector } from '../types';

export type PassportAnalytics = {
  page_level: number | string;
  page_country: string | string[];
  page_region: string | string[];
  page_program: string[];
  page_status: string;
  page_type: 'Passport Page';
  page_purpose: 'Traffic and conversion';
  page_initiator: 'CEO';
  page_expert: string;
  page_author: string;
  program_relation: string;
  page_language: string;
};

export const collectDataForPassportAnalytics: AnalyticsDataCollector<
  PassportPageStoryblok,
  PassportAnalytics
> = async (story, locale) => {
  const { published_at, first_published_at, content } = story;

  const {
    pageStatus = '',
    programRelation = '',
    pageCountry,
    category,
    pageProgram,
  } = content;

  const categories = await getCategoriesDatasource(locale);

  const datasourceCategory = categories.find((c) => c.value === category);

  const categoryName = datasourceCategory
    ? datasourceCategory.dimension_value
    : '';

  const investmentProgramNamesRaw = pageProgram
    ? await getInvestmentProgramNames([pageProgram])
    : [];

  const investmentProgramNames: string[] = Array.isArray(
    investmentProgramNamesRaw
  )
    ? investmentProgramNamesRaw
    : [investmentProgramNamesRaw];

  return {
    page_update_date: createPageDate(published_at),
    page_first_published_date: createPageDate(first_published_at),
    page_level: NONE_VALUE,
    page_expert: NONE_VALUE,
    page_author: NONE_VALUE,
    page_program: investmentProgramNames,
    page_status: pageStatus,
    program_relation: programRelation,
    page_country: createPageCountry(pageCountry),
    page_region: NONE_VALUE,
    page_type: 'Passport Page',
    page_purpose: 'Traffic and conversion',
    page_initiator: 'CEO',
    page_category: categoryName,
    page_language: locale,
  };
};
